import { type FunctionComponent, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import { Button } from '~/ui/core/button/Button';
import { IconArrowExpandHor } from '~/ui/core/icons';

import type { JobItemDetails } from '../../api/use-job-item-details';
import { useJobArchitectureUrlTileActions } from '../../url-tiles/use-job-architecture-url-tile-actions';

export const CompareVersionButton: FunctionComponent<{
    readonly currentVersion: string;
    readonly item: JobItemDetails;
    readonly lastPublishedVersion: { readonly version: number };
}> = ({ currentVersion, item, lastPublishedVersion }) => {
    const { translate } = useContext(ApplicationContext);
    const { openCompareTile } = useJobArchitectureUrlTileActions();

    const handleCompare = (): void => {
        openCompareTile({
            profileId: item.id,
            type: item.type,
            versionA: lastPublishedVersion.version.toString(),
            versionB: currentVersion,
        });
    };

    return (
        <Button iconPosition="leading" variant="tertiary" onClick={handleCompare}>
            <IconArrowExpandHor style={{ height: '16px', width: '16px' }} />
            {translate('pages.job-architecture-v2.job-profile-compare-versions')}
        </Button>
    );
};
